import React from 'react'
import FormPage from '../FormPage'
import Auth from "../../Auth";
import ReactDOM from "react-dom";
import {useParams, Link} from "react-router-dom";

export default class AuthTalentSignup extends FormPage
{
    static path = '/signup/talent/:token';

    /**
     * The title shown on the form
     */
	static FormViewTitle = "auth.signup.talent.title";

    /**
     * The title shown on the form
     */
	static FormViewSubtitle = "auth.signup.talent.subtitle";

	/**
     * The submit button title for the form
     */
	static FormSubmit = TB.trans("auth.signup.talent.submit_button");

    /**
     * The links mapping for the form
     */
    static FormViewLinks = [
        {
            title: 'auth.signup.talent.subtitle_login_link',
            path: '/login',
        }
    ];

	/**
     * The fields mapping for the form
     */
    static FormFields = {

        title: this.renderTitle(),

    	first_name: {
            label: 'auth.signup.talent.first_name_label',
            placeholder: TB.trans('auth.signup.talent.first_name_placeholder'),
        },
    	last_name: {
            label: 'auth.signup.talent.last_name_label',
            placeholder: TB.trans('auth.signup.talent.last_name_placeholder'),
        },
    	email: {
            type: 'email',
            label: 'auth.signup.talent.email_label',
            placeholder: TB.trans('auth.signup.talent.email_placeholder'),
        },
        password: {
            type: 'new_password',
            label: 'auth.signup.talent.password_label',
            placeholder: TB.trans('auth.signup.talent.password_placeholder'),
        },
        password_confirmation: {
            type: 'password_confirmation',
            label: 'auth.signup.talent.confirm_password_label',
            placeholder: TB.trans('auth.signup.talent.confirm_password_placeholder'),
        },
        // remember_me: {
        //     type: 'checkbox',
        //     label: 'auth.signup.talent.remember_label',
        //     required: false
        // },
    };

    validateBeforeSubmit = true;

   	/**
     * [Constructor]
     *
     * @param {Object} props
     * @returns {FormPage}
     */
    constructor(props)
    {
		super(props);

        let user = laravel.referred_user
            || {};

		this.state = {
			...this.state,
			isDisabled: false,
			model: {...user},
		};
	}

    static formViewTitle()
    {
        return TB.tryTrans(
            this.FormViewTitle
        );
    }

    static formViewSubtitle()
    {
        return TB.tryTrans(
            this.FormViewSubtitle
        );
    }

    static formViewLinks()
    {
        return this.FormViewLinks;
    }

    /**
     * Maps form input data to form submit model
     * Appends token to form data from url route parameter
     *
     * @param {Object} model
     * @returns {Object}
     */
    mapping(model)
    {
        model.referral_token = this.props.token;

        return model;
    }

   	/**
     * Handles form submit button clicks when form is valid
     *
     * @param {Object} creds
     * @returns void
     */
	async onSubmit(creds)
	{
        let postData = { ...creds };

        if (this.hasQueryParam('ref')) {
            postData.referred_by = this.queryParam('ref');
        }
        if (this.hasQueryParam('ref_name')) {
            postData.referred_by_name = this.queryParam('ref_name');
        }

		// TB.log().object(
		// 	'Talent Signup @ onSubmit', { ...postData }
		// );

		let isDisabled = true;
		await this.promisedState({isDisabled});

        let auth = TB.auth();
        let user = await auth.talentSignup(postData).catch(console.warn);
        if (!auth.NeedsTwoFactorConfirmed
            && !user
            && this.formRef.current)
        {
            await this.promisedState({isDisabled: false})
            return this.onError(user)
        }

        return this.promisedState({isDisabled})
	}

	async onError(e) {

	    if ( Auth.TalentSignupRequest.didFail
            && Auth.TalentSignupRequest.statusCode() === 422
            && this.formRef.current) {
            try {
                let invalid = await this.formRef.current.handleInputResponseError(Auth.TalentSignupRequest)
                if(invalid) {
                    const node = ReactDOM.findDOMNode(invalid);

                    $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
                    return false;
                }
            }catch (e) {
                console.warn('ERROR: handleInputResponseError', e);
            }
         }
    }

	// async onSuccess(response) {
    //
    //     try {
    //         Auth.User = {...response.data.auth};
    //         Auth.DidExpire = false;
    //
    //         await Auth.onUpdate();
    //
    //         TB.event('Auth@Update');
    //
    //         console.log('Auth', this.context?.auth)
    //     }catch (e) {
    //         console.log('ERROR: onSuccess', e);
    //     }
    // }

    /**
     * Render the form
     *
     * @returns {Form}
     */
	render()
	{
		return (
            <div className='container-fluid'>

                {this.renderFormView()}

            </div>
		);
	}

    /**
     * Overridable method for rendering any form child elements
     *
     * @returns {Component}
     */
    renderFormView()
    {
        return (
            <div className="signup-banner">
                <div className="branding">

                    {laravel.platform_settings.Asset_Logo_Brand_Image?.length > 0 && (
                        <div className="logo-heading" style={{backgroundImage: `url("${laravel.platform_settings.Asset_Logo_Brand_Image}")`}}/>
                    )}

                    <h3 className="py-2 px-4 my-8 mb-4 bg-secondary text-white">For Freelancers</h3>

                    <svg className="heading" viewBox="0 0 115 20">
                        <text fill={TB.config("color.light_purple")} x="0" y="15">
                            {TB.trans('talent.banner.logo_heading_1')}
                        </text>
                    </svg>
                    <svg className="heading" viewBox="0 0 115 20">
                        <text fill={TB.config("color.light_purple")} x="0" y="15">
                            {TB.trans('talent.banner.logo_heading_2')}
                        </text>
                    </svg>
                    <svg className="heading" viewBox="0 0 115 20">
                        <text fill={TB.config("color.light_purple")} x="0" y="15">
                            {TB.trans('talent.banner.logo_heading_3')}
                        </text>
                    </svg>
                    <svg className="heading" viewBox="0 0 115 20">
                        <text fill={TB.config("color.light_purple")} x="0" y="15">
                            {TB.trans('talent.banner.logo_heading_4')}
                        </text>
                    </svg>
                    <p className="subheading">
                        {TB.trans('talent.banner.sub_heading')}
                    </p>
                </div>

                <div className="signup-form py-4 bg-white mb-6 md:mx-0 md:mb-0">
                    {this.renderForm()}
                </div>

            </div>
        );
    }

    static renderTitle() {
        let links = this.formViewLinks();

        return (
            <div className="form-title-section">
                <h3 className="form-title">
                    {this.formViewTitle()}
                </h3>
                <h5 className="form-subtitle">
                    {this.formViewSubtitle()}

                    {links.map((link,i) => (
                        <Link key={`signup-link-${i}`}
                            to={link.path}
                            aria-label={TB.tryTrans(link.title)}>
                            {TB.tryTrans(link.title)}
                        </Link>
                    ))}

                </h5>
            </div>
        )
    }
}


const TalentSignup = (props) => {
    const {token} = useParams();

    return (
        <AuthTalentSignup token={token}/>
    )
}

export {
    TalentSignup
}